import React from "react";
import { useTranslation } from "react-i18next";

const RecapCard = ({
  icon,
  borderColor="border-[var(--color-primary)]",
  title,
  titleColor="text-[var(--color-primary)]",
  state,
  stateDraftColor="text-[var(--color-orange)]",
  stateValidColor="text-green-600",
  stateLabel,
  fields,
  info,
  onEdit,
  editLabel,
  onDelete,
  showDelete,
  deleteColor="border-[var(--color-orange)] text-[var(--color-orange)]",
  editColor="border-[var(--color-primary)] text-[var(--color-primary)] hover:bg-[var(--bg-hover)] hover:text-white"
}) => {
  const { t } = useTranslation();
  return (
  <div className="col-span-1 md:col-span-3">
    <div className={`rounded-xl p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 shadow-sm mb-2 bg-[var(--bg-color)] border ${borderColor}`}>
      <div className="flex items-center gap-4">
        <div className={`flex items-center justify-center w-14 h-14 rounded-full bg-white border ${borderColor} shadow-sm`}>
          {icon}
        </div>
        <div>
          <div className={`font-bold text-lg mb-1 flex gap-4 ${titleColor}`}>
            {title}
            <span className={state === "draft" ? stateDraftColor : stateValidColor}>
              {stateLabel}
            </span>
          </div>
          <div className="text-gray-700 space-y-1">
            {fields.map((f, i) => (
              <div key={i}>
                <span className="font-medium">{f.label}</span> {f.value}
              </div>
            ))}
          </div>
          <div className={`mt-2 text-sm ${titleColor} opacity-70`}>
            {info}
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-2 mt-4 md:mt-0">
        {onEdit && (
          <button
            className={`px-4 py-2 rounded-lg border font-medium transition-all ${editColor} bg-white hover:bg-green-600 hover:text-white`}
            onClick={onEdit}
          >
            {editLabel || t('absenceType.edit')}
          </button>
        )}
        {showDelete && (
          <button
            className={`px-4 py-2 rounded-lg border font-medium transition-all ${deleteColor} bg-white hover:bg-[var(--color-orange)] hover:text-white`}
            onClick={onDelete}
          >
            {t('hspForm.delete')}
          </button>
        )}
      </div>
    </div>
  </div>
  );
};

export default RecapCard;